import { create } from "zustand";
import type { UserInfoState } from "./types";

export const useUserInfoStore = create<UserInfoState>((set) => ({
  isLoading: false,
  errorMessage: null,
  name: "",
  surname: "",
  password: "",
  confirmPassword: "",
  setName: (name) => set({ name }),
  setSurname: (surname) => set({ surname }),
  setPassword: (password) => set({ password }),
  setConfirmPassword: (confirmPassword) => set({ confirmPassword }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (message) => set({ errorMessage: message }),
  reset: () =>
    set({
      isLoading: false,
      errorMessage: null,
      name: "",
      surname: "",
      password: "",
      confirmPassword: "",
    }),
}));
